import { AuthError, AuthErrorCode } from '../types/auth';

export const handleAuthError = (error: AuthError): string => {
  const errorCode = error.code as AuthErrorCode;
  
  const errorMessages: Record<AuthErrorCode, string> = {
    'auth/email-already-in-use': "Cette adresse email est déjà utilisée",
    'auth/invalid-email': "L'adresse email n'est pas valide",
    'auth/operation-not-allowed': "Cette opération n'est pas autorisée",
    'auth/weak-password': "Le mot de passe est trop faible",
    'auth/user-disabled': "Ce compte a été désactivé",
    'auth/user-not-found': "Aucun compte ne correspond à cette adresse email",
    'auth/wrong-password': "Le mot de passe est incorrect",
    'auth/invalid-credential': "Les identifiants sont invalides",
    'auth/too-many-requests': "Trop de tentatives, veuillez réessayer plus tard",
    'auth/invalid-action-code': "Ce lien de réinitialisation n'est plus valide",
    'auth/expired-action-code': "Ce lien de réinitialisation a expiré"
  };

  return errorMessages[errorCode] || "Une erreur est survenue lors de l'authentification";
};